/*@flow*/
import * as t from 'lib/t';
import { Id, NormalizedNumber } from 'types/tcomb';
import enumsFor from './util/enumsFor';
import mkTagTemplate from 'lib/templates/mkTagTemplate';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  name: t.String,
  address: t.maybe(t.String).options({
    template: 'LocationPickerTemplate',
  }),
  theGeom: t.String.options({ type: 'hidden' }),
  visibility: enumsFor('visibility').opt({
    nullOption: { value: '', text: 'Choose visibility' },
  }),
  status: t.String.options({
    template: 'UnitStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  category: t.maybe(t.String).options({
    template: 'UnitCategory',
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  subcategories: t.maybe(t.list(t.String)).options({
    template: 'UnitSubcategory',
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  use: t.maybe(
    enumsFor('use').opt({
      nullOption: { value: '', text: 'Choose a use' },
    })
  ),
  notes: t
    .maybe(t.String)
    .options({ type: 'textarea', template: 'TextEditorTemplate' }),
  floor: t.maybe(t.String),
  suite: t.maybe(t.String),
  rentableSqft: t.maybe(NormalizedNumber),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('units'),
    attrs: {
      placeholder: 'Select...',
      classNamePrefix: 'Select',
    },
  }),
  photoUrls: t.maybe(t.list(t.String)).options({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  annualDistrictPayment: t.maybe(NormalizedNumber),
  districtPropertyClass: t.maybe(t.String),
  contactName: t.maybe(t.String).opt({
    before: {
      tag: 'h3',
      props: { children: 'Contact', className: 'mt-5' },
    },
    label: 'Contact',
  }),
  contactEmail: t.maybe(t.String).opt({ label: 'Email' }),
  contactPhone: t.maybe(t.String).opt({
    label: 'Phone',
  }),
};

export default t.struct(config, { name: 'Unit' }).opt<any>({ legend: '' });
